import { Component } from '@angular/core';
import { LayoutColumnComponent } from './column.component';

@Component({
  standalone: false,
  selector: 'mf-row-separator',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.scss'],
})
export class LayoutRowSeparatorComponent extends LayoutColumnComponent {
  constructor() {
    super();
    this.md = 12;
    this.noPadding = true;
    this.minHeight = 30;
  }
}
